import React from "react";

/**
 * The mintikk signature: lowercase wordmark + two small mint dots.
 * Never capitalise the wordmark, never drop the dots.
 */
export const Wordmark = ({ className = "", dotClassName = "", ...props }) => {
  return (
    <span className={`mk-wordmark ${className}`} {...props}>
      mintikk
      <span className={`mk-dots ${dotClassName}`} aria-hidden="true">
        <i className="mk-dot" />
        <i className="mk-dot" />
      </span>
    </span>
  );
};

export default Wordmark;
